// extracted by css-extract-rspack-plugin
export default {"root":"MenuItem_root__zePia"};